import { useContext } from 'react';

import * as Sentry from '@sentry/remix';

import { PostDataContext } from './PostDataContext';

export const usePostDataContext = () => {
  const context = useContext(PostDataContext);
  if (!context) {
    Sentry.captureMessage('[PostDataProvider] usePostDataContext must be used within a PostDataProvider');
    throw new Error('usePostDataContext must be used within a PostDataProvider');
  }
  return context;
};
